import { css, cx } from "@linaria/core";
import { DetailedHTMLProps, HTMLAttributes } from "react";

const svgCss = css`
  /**
   * svg implements it's own pointer event system, which rarely works the way
   * you'd expect usually - simply disable pointer events all together to avoid
   * confusion.
   */
  pointer-events: none;
`;

export const SVG = (
  props: DetailedHTMLProps<HTMLAttributes<SVGSVGElement>, SVGSVGElement>,
) => {
  return <svg {...props} className={cx(props.className, svgCss)} />;
};
